export default {
  en: require('@/translations/en.json')
}



// WEBPACK FOOTER //
// ./src/translations/messages.js